export { GoogleSsoSignUpForm, type TGoogleSsoSignUpFormProps } from './GoogleSsoSignUpForm';
